import type { MouseEvent } from 'react';
import type { OrderProductStatusId } from '@witmetrics/utils';
import { ORDER_PRODUCT_STATUSES } from '@witmetrics/utils/constants';
import Menu, { MenuItem, type MenuProps } from '@/components/Menu';
import OrderProductStatusCircle from '@/components/OrderProductStatusCircle';
import { classes } from './utils';

export interface OrderProductStatusMenuProps extends MenuProps {
  onChange: (orderProductStatusId: OrderProductStatusId) => void;
}

export default function OrderProductStatusMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onChange,
  onClose,
}: OrderProductStatusMenuProps) {
  const handleChange = (
    e: MouseEvent,
    orderProductStatusId: OrderProductStatusId
  ) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(orderProductStatusId);
    onClose();
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={classes.menu}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <ul>
        {Object.values(ORDER_PRODUCT_STATUSES).map((status) => (
          <MenuItem
            key={status.id}
            label={status.label}
            icon={
              <OrderProductStatusCircle
                className={classes.icon}
                orderProductStatusId={status.id}
                size={18}
              />
            }
            onClick={(e) => handleChange(e, status.id)}
          />
        ))}
      </ul>
    </Menu>
  );
}
